import AdminManagementTable from './AdminManagementTable';
import AdminManagementCard from './AdminManagementCard';
import { FC, useState } from 'react';
import { Card } from 'src/shared/components/index';
import { AdminData } from '../models';
import { I18N, LIST_VIEW } from 'src/shared/constants/constants';
import CustomDeleteModal from 'src/shared/modals/CustomDeleteModal';
import { useTranslation } from 'react-i18next';

interface AdminManagementViewProps {
  className?: string;
  handleEditIconClick: (row: any) => void;
  handleDeleteIconClick: (email: any) => void;
  handleSwitchIconClick(email: any): void;
  inputSelectedTab: string;
  inputAminUserData: AdminData[];
}

const AdminManagementView: FC<AdminManagementViewProps> = ({
  handleEditIconClick,
  handleDeleteIconClick,
  handleSwitchIconClick,
  inputAminUserData,
  inputSelectedTab
}) => {
  const [deleteDialogDetails, setDeleteDialogDetail] = useState();
  const { t } = useTranslation(I18N.ADMIN_USER);
  const handleDeleteIconClickEvent = (detail) => setDeleteDialogDetail(detail);
  const confirmDelete = () => {
    handleDeleteIconClick(deleteDialogDetails);
    setDeleteDialogDetail(null);
  };
  return (
    <>
      {inputSelectedTab === LIST_VIEW.CARD_VIEW && (
        <AdminManagementCard
          handleDeleteIconClick={handleDeleteIconClickEvent}
          handleEditIconClick={handleEditIconClick}
          inputAminUserData={inputAminUserData}
        />
      )}
      {inputSelectedTab === LIST_VIEW.TABLE_VIEW && (
        <Card className="mb-25">
          <AdminManagementTable
            handleEditIconClick={handleEditIconClick}
            handleDeleteIconClick={handleDeleteIconClickEvent}
            handleSwitchIconClick={handleSwitchIconClick}
            inputAminUserData={inputAminUserData}
          />
        </Card>
      )}
      <CustomDeleteModal
        open={deleteDialogDetails ? true : false}
        title={t('dialog.delete.admin.title')}
        subtitle={t('dialog.delete.admin.subtitle')}
        name={deleteDialogDetails}
        onDelete={confirmDelete}
        onClose={() => setDeleteDialogDetail(null)}
      />
    </>
  );
};

export default AdminManagementView;
